import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

/**
 * Indicates how risky a given subaward is
 */
export enum SubawardRisk {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}
// Needs to be before namespace is defined
const JOB_TYPES: ReadonlySet<SubawardRisk> = new Set(
  Object.values(SubawardRisk) as SubawardRisk[],
)
export namespace SubawardRisk {
  export const ALL: readonly SubawardRisk[] = Array.from(JOB_TYPES)
  export const isSubawardRisk = TypeChecker.Factory.oneOf(JOB_TYPES)
  export const assertIsSubawardRisk: TypeAsserter<SubawardRisk> =
    TypeAsserter.Factory.from(isSubawardRisk)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link SubawardRisk}
   */
  export function getEntry(
    jobType: SubawardRisk,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[jobType], id: jobType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    SubawardRisk,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [SubawardRisk.High]: {
      name: 'High',
    },
    [SubawardRisk.Medium]: {
      name: 'Medium',
    },
    [SubawardRisk.Low]: {
      name: 'Low',
    },
  }
}
